export type Article = {
  id: number;
  slug: string;
  title: string;
  updatedAt: string;
  popular: boolean;
};

export type ArticleWithCategory = Article & {
  category: string;
  categoryName: string;
};

export const articlesByCategory: Record<string, Article[]> = {
  'primeiros-passos': [
    {
      id: 1,
      slug: 'enviando-sua-primeira-mensagem',
      title: 'Enviando sua primeira mensagem',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
    {
      id: 2,
      slug: 'editar-citar-e-reagir-a-mensagens',
      title: 'Editar, citar e reagir a mensagens',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
    {
      id: 3,
      slug: 'smilies-os-emojis-do-xat',
      title: 'Smilies — os emojis do xat',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
    {
      id: 4,
      slug: 'gifs-e-efeitos-sonoros',
      title: 'GIFs e efeitos sonoros',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
    {
      id: 5,
      slug: 'mensagens-e-chats-privados',
      title: 'Mensagens e chats privados',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
    {
      id: 6,
      slug: 'entendendo-a-lista-de-visitantes',
      title: 'Entendendo a lista de visitantes',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
    {
      id: 7,
      slug: 'adicionar-amigos-ignorar-e-bloquear',
      title: 'Adicionar amigos, ignorar e bloquear',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
    {
      id: 8,
      slug: 'personalize-seu-perfil',
      title: 'Personalize seu perfil',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
    {
      id: 9,
      slug: 'configuracoes-da-conta',
      title: 'Configurações da conta',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
    {
      id: 10,
      slug: 'por-que-criar-uma-conta',
      title: 'Por que criar uma conta?',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
  ],
  account: [
    {
      id: 1,
      slug: 'como-criar-uma-conta-no-xat',
      title: 'Como criar uma conta no xat',
      updatedAt: 'Há 2 meses',
      popular: true,
    },
    {
      id: 2,
      slug: 'redefinir-sua-senha-com-seguranca',
      title: 'Redefinir sua senha com segurança',
      updatedAt: 'Há 1 mês',
      popular: false,
    },
    {
      id: 3,
      slug: 'alterar-endereco-de-e-mail',
      title: 'Alterar endereço de e-mail',
      updatedAt: 'Há 3 semanas',
      popular: false,
    },
    {
      id: 4,
      slug: 'configurar-autenticacao-em-dois-fatores',
      title: 'Configurar autenticação em dois fatores',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
  ],
  safety: [
    {
      id: 1,
      slug: 'diretrizes-da-comunidade-xat',
      title: 'Diretrizes da comunidade xat',
      updatedAt: 'Há 2 meses',
      popular: true,
    },
    {
      id: 2,
      slug: 'como-denunciar-abuso-ou-conteudo-improprio',
      title: 'Como denunciar abuso ou conteúdo impróprio',
      updatedAt: 'Há 1 mês',
      popular: false,
    },
    {
      id: 3,
      slug: 'protegendo-sua-privacidade',
      title: 'Protegendo sua privacidade',
      updatedAt: 'Há 2 semanas',
      popular: false,
    },
  ],
  powers: [
    {
      id: 1,
      slug: 'guia-completo-de-powers',
      title: 'Guia completo de Powers',
      updatedAt: 'Há 2 meses',
      popular: true,
    },
    {
      id: 2,
      slug: 'como-comprar-powers',
      title: 'Como comprar Powers',
      updatedAt: 'Há 1 mês',
      popular: true,
    },
    {
      id: 3,
      slug: 'transferir-powers-entre-contas',
      title: 'Transferir Powers entre contas',
      updatedAt: 'Há 3 semanas',
      popular: false,
    },
  ],
  chats: [
    {
      id: 1,
      slug: 'criar-sua-primeira-sala-de-chat',
      title: 'Criar sua primeira sala de chat',
      updatedAt: 'Há 2 meses',
      popular: true,
    },
    {
      id: 2,
      slug: 'gerenciar-moderadores-efetivamente',
      title: 'Gerenciar moderadores efetivamente',
      updatedAt: 'Há 1 mês',
      popular: false,
    },
    {
      id: 3,
      slug: 'personalizar-aparencia-do-chat',
      title: 'Personalizar aparência do chat',
      updatedAt: 'Há 2 semanas',
      popular: false,
    },
  ],
  store: [
    {
      id: 1,
      slug: 'metodos-de-pagamento-aceitos',
      title: 'Métodos de pagamento aceitos',
      updatedAt: 'Há 2 meses',
      popular: false,
    },
    {
      id: 2,
      slug: 'politica-de-reembolsos',
      title: 'Política de reembolsos',
      updatedAt: 'Há 1 mês',
      popular: false,
    },
    {
      id: 3,
      slug: 'gerenciar-historico-de-compras',
      title: 'Gerenciar histórico de compras',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
  ],
  troubleshooting: [
    {
      id: 1,
      slug: 'resolver-problemas-de-login',
      title: 'Resolver problemas de login',
      updatedAt: 'Há 2 meses',
      popular: true,
    },
    {
      id: 2,
      slug: 'erro-ao-carregar-salas-de-chat',
      title: 'Erro ao carregar salas de chat',
      updatedAt: 'Há 1 mês',
      popular: false,
    },
    {
      id: 3,
      slug: 'otimizar-performance-do-xat',
      title: 'Otimizar performance do xat',
      updatedAt: 'Há 1 semana',
      popular: false,
    },
    {
      id: 4,
      slug: 'erros-do-xat',
      title: 'Erros do xat',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
    {
      id: 5,
      slug: 'sistema-de-tickets-do-xat',
      title: 'Sistema de tickets do xat',
      updatedAt: 'Há 1 semana',
      popular: true,
    },
  ],
  mobile: [
    {
      id: 1,
      slug: 'instalar-xat-no-ios',
      title: 'Instalar xat no iOS',
      updatedAt: 'Há 1 mês',
      popular: true,
    },
    {
      id: 2,
      slug: 'configurar-notificacoes-mobile',
      title: 'Configurar notificações mobile',
      updatedAt: 'Há 2 semanas',
      popular: false,
    },
  ],
  'xat-live': [
    {
      id: 1,
      slug: 'iniciar-chamada-de-video',
      title: 'Iniciar chamada de vídeo',
      updatedAt: 'Há 1 mês',
      popular: true,
    },
    {
      id: 2,
      slug: 'configurar-qualidade-de-streaming',
      title: 'Configurar qualidade de streaming',
      updatedAt: 'Há 2 semanas',
      popular: false,
    },
  ],
};

export const categoryNames: Record<string, string> = {
  'primeiros-passos': 'Primeiros Passos',
  account: 'Gestão de Conta',
  safety: 'Segurança e Privacidade',
  powers: 'Powers e Recursos Premium',
  chats: 'Salas de Chat',
  store: 'Loja e Pagamentos',
  troubleshooting: 'Solução de Problemas',
  mobile: 'Aplicativos Mobile',
  'xat-live': 'xat Live',
};

export const categoryColors: Record<string, string> = {
  'primeiros-passos': 'bg-indigo-100 text-indigo-700',
  account: 'bg-blue-100 text-blue-700',
  safety: 'bg-emerald-100 text-emerald-700',
  powers: 'bg-amber-100 text-amber-700',
  chats: 'bg-sky-100 text-sky-700',
  store: 'bg-violet-100 text-violet-700',
  troubleshooting: 'bg-rose-100 text-rose-700',
  mobile: 'bg-cyan-100 text-cyan-700',
  'xat-live': 'bg-fuchsia-100 text-fuchsia-700',
};

export const allArticles: ArticleWithCategory[] = Object.entries(articlesByCategory).flatMap(
  ([category, arts]) =>
    arts.map((art) => ({ ...art, category, categoryName: categoryNames[category] }))
);

export function findArticleByCategoryAndSlug(category: string, slug: string): Article | undefined {
  return articlesByCategory[category]?.find((a) => a.slug === slug);
}
